import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarX2, TimerOff, Smartphone, BatteryWarning } from 'lucide-react';
export function FailedMethods() {
  const methods = [{
    icon: <CalendarX2 className="w-8 h-8 text-slate-400" data-id="element-15" />,
    title: 'Agendas Tradicionales',
    description: 'Se convierten rápidamente en listas de pruebas de tu fracaso diario.'
  }, {
    icon: <TimerOff className="w-8 h-8 text-slate-400" data-id="element-16" />,
    title: 'Método Pomodoro',
    description: "Te interrumpe justo cuando logras entrar en el escaso 'hiperfoco', rompiendo tu ritmo."
  }, {
    icon: <Smartphone className="w-8 h-8 text-slate-400" data-id="element-17" />,
    title: 'Apps de Productividad',
    description: 'Añaden una capa extra de complejidad (fricción) que termina por agobiarte.'
  }, {
    icon: <BatteryWarning className="w-8 h-8 text-slate-400" data-id="element-18" />,
    title: 'Fuerza de Voluntad',
    description: 'Intentar usarla es como tratar de arrancar un coche sin batería a base de gritos.'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-19">
      <FadeIn data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-22">
            Por qué lo que has intentado{' '}
            <span className="text-red-400" data-id="element-23">no funcionó</span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-24">
            El sistema tradicional está roto para ti. No es tu culpa que estas
            herramientas te hayan fallado.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
        {methods.map((method, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
            <div className="bg-[#111827] border border-slate-800 p-6 rounded-2xl h-full flex flex-col items-start hover:border-slate-700 transition-colors" data-id="element-27">
              <div className="mb-4 bg-slate-800/50 p-3 rounded-xl" data-id="element-28">
                {method.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-29">
                {method.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-30">
                {method.description}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}